module.exports = __webpack_public_path__ + "static/img/earn-small.add786ed.png";